<template>
    <v-container fluid fill-height>
        <v-card  outlined width="100%" class="fill-height">
            <v-card-text class="pa-5">
                <v-row>
                    <v-col cols=6 md=6 lg=6 sm=6>
                        <v-chip label color="amber"> <v-icon left>mdi-cube-outline</v-icon>Products Manager</v-chip>
                    </v-col>
                    <v-col cols=6 md=6 lg=6 sm=6 style="postion:relative">
                        <v-speed-dial v-model="fab" direction="left" :open-on-hover="false" 
                        transition="slide-y-reverse-transition" class="Speed-button-Setting">
                            <template v-slot:activator>
                                <v-btn v-model="fab" color="amber" fab class="elevation-0">
                                <v-icon v-if="fab">mdi-close</v-icon>
                                <v-icon v-else>mdi-cube-outline</v-icon>
                                </v-btn>
                            </template>
                            <v-btn fab dark small color="indigo" @click="CreateBox = true"><v-icon>mdi-plus</v-icon></v-btn>
                            <v-btn v-if="selection.length > 0" fab dark small color="red" @click="deleteBox=true">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-speed-dial>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12 md=12 lg=12 sm=12>
                        <v-data-table :headers="headers" :items="records" :search="search" v-model="selection" :show-select="role =='admin' ? true : false">
                            <template v-slot:item.check="{ item }">
                                <router-link :to="{name:'order',params:{product:item.id}}"><v-btn color="amber" fab small class="elevation-0"><v-icon>mdi-eye</v-icon></v-btn></router-link>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-btn color="amber" fab small class="elevation-0" @click="EditBox = true; productId=item.id"><v-icon color="black">mdi-pencil</v-icon></v-btn>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row> 
            </v-card-text>           
        </v-card>
        <v-dialog v-model="CreateBox" fullscreen hide-overlay transition="dialog-bottom-transition">
            <Product :edit="false" @Response="action($event)" @Close="CreateBox = false"></Product>
        </v-dialog>
        <v-dialog v-model="EditBox" fullscreen hide-overlay transition="dialog-bottom-transition">
            <Product :edit="true" :id='productId' @Response="action($event)" @Close="EditBox = false"></Product>
        </v-dialog>
        <v-dialog v-model="deleteBox" scrollable persistent max-width="500px" transition="dialog-transition">
            <delConfirm :url="delUrl" :selectedId="deleteconveter" ></delConfirm>
        </v-dialog>
        <v-snackbar v-model="notificationBar" top center :color="notificationColor" multi-line> {{ notificationText }}
            <v-btn color="amber" text @click="notificationBar = false"> Close </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import Product from '../../components/product/index'
import delConfirm from '../../components/confirmation/index.vue'
import {bus} from '../../main'
import { SERVER_API } from '../../API';
import {store} from '../../store'
export default {
    components:{Product,delConfirm},
    mounted(){
        this.fetchall();
    },
    computed:{
        deleteconveter(){
            var deleteId = [...new Set(this.selection.map(it => it.id))];
            return deleteId.toString();
        }
    },
    created(){
        bus.$on('close',() =>  {
            this.deleteBox = false;
            this.selection = [];
        });

        bus.$on('deleted', () =>  {
            for(let i = 0; i < this.selection.length; i++){
                if(this.records.indexOf(this.selection[i])!= -1){
                    this.records.splice(this.records.indexOf(this.selection[i]),1);
                }
            }
        });            
    },
    data(){
        return{
            role:store.state.role,
            delUrl:SERVER_API+'/product/delete',
            productId:'',
            EditBox:false,
            CreateBox:false,
            search:'',
            fab:false,
            headers:[
                { text: 'Product Name', value: 'name' },
                { text: 'Product Nature', value: 'nature' },
                { text: 'Product Form', value: 'pF' },
                { text: 'Product Status', value: 'preFix' },
                { text: 'Order Check', value: 'check' },
                { text: 'Action', value: 'action' },
            ],
            records:[],
            deleteBox:false,
            // Selection of Data
            selection:[],

            // Notification Setting
            notificationColor: 'black',
            notificationBar: false,
            notificationText:''
        }
    },
    methods:{
        async fetchall(){
            const response =  await this.$http.get(SERVER_API+'/product/records');
            this.records = response.data.data;
        },
        action(e){
            if(e.action == true){
                this.notificationColor = 'black';
                this.notificationBar = true;
                this.notificationText = e.message;
                this.fetchall();
                this.CreateBox = false;
                this.EditBox = false;
            }else{
                this.notificationColor = 'red';
                this.notificationBar = true;
                this.notificationText = e.message;
                //console.log(e);
            }

        }
    }

}
</script>

<style>
.Speed-button-Setting{
    position:absolute;
    right:30px;
}
</style>